import CheckoutsPage from 'dispensary/checkouts';

export default CheckoutsPage;
